import {SafeHtml} from "@angular/platform-browser";

export class UserNotification {
  public outletMessageId: string;
  public title:string;
  public body: string;
  public safeBody: SafeHtml;
  public bodyType: NotificationBodyType;
  public isRead: boolean;
  public createDate: Date;
}

export enum NotificationBodyType {
  'Html' = 0,
  'Text' = 1
}
